// Single source of truth for the staff Position dropdown displayed in every
// Position-aware UI (Edit Employee dialog, Add/Invite dialogs, Job
// Applications list, My Profile read-only display). Mirrors the
// POSITION_OPTIONS constant in /app/backend/server.py — change both if the
// product ever ships a new staff classification.
export const POSITION_OPTIONS = [
  'Door Supervisor (SIA)',
  'CSO Steward',
];
